import React from 'react';

import { chakra } from '@chakra-ui/react';

import { createColumnHelper } from '@tanstack/react-table';

import { convertUTCToLocal } from 'utils/dateUtils';
import { TransferStatusColorMap, TransferStatusMap } from 'constants/transfer';
import { isEquipmentTransfersEnabled } from 'constants/featureFlags';

const Span = chakra('span');

/** TransferStatusEnum.EMPTY: the category had nothing to transfer. */
const TRANSFER_STATUS_EMPTY = 6;

/** fetchTransferList returns untyped items; the legacy table rendered `any`. */
export type TransferRow = any;

const col = createColumnHelper<TransferRow>();

export const buildTransferColumns = () => [
  col.accessor((item) => item?._id, {
    id: '_id',
    header: 'ID',
    minSize: 180,
  }),
  col.accessor((item) => item?.scanId, {
    id: 'scanId',
    header: 'Scan ID',
    minSize: 130,
  }),
  col.display({
    id: 'status',
    header: 'Status',
    minSize: 200,
    size: 320,
    meta: { truncate: false },
    cell: ({ row: { original: item } }) => {
      const itemsColor = TransferStatusColorMap[item?.status?.items?.status];
      const casesColor = TransferStatusColorMap[item?.status?.cases?.status];
      const packsColor = TransferStatusColorMap[item?.status?.packages?.status];
      // Transfers made before equipment existed have no equipment status;
      // show them as the grey N/A pill (EMPTY), like an empty category.
      const equipmentColor =
        TransferStatusColorMap[
          item?.status?.equipment?.status ?? TRANSFER_STATUS_EMPTY
        ];

      return (
        <>
          Items -{' '}
          <Span
            m="1px"
            bg={`${itemsColor}.100`}
            color={`${itemsColor}.500`}
            p="5px 10px"
            borderRadius="10px"
            fontWeight="bold">
            {TransferStatusMap[item?.status?.items?.status] || 'N/A'}
          </Span>
          <br />
          <br />
          Cases -{' '}
          <Span
            m="1px"
            bg={`${casesColor}.100`}
            color={`${casesColor}.500`}
            p="5px 10px"
            borderRadius="10px"
            fontWeight="bold">
            {TransferStatusMap[item?.status?.cases?.status] || 'N/A'}
          </Span>
          <br />
          <br />
          Packages -{' '}
          <Span
            m="1px"
            bg={`${packsColor}.100`}
            color={`${packsColor}.500`}
            p="5px 10px"
            borderRadius="10px"
            fontWeight="bold">
            {TransferStatusMap[item?.status?.packages?.status] || 'N/A'}
          </Span>
          {/* Equipment in Transfers is behind a flag until the client
              approves it. */}
          {isEquipmentTransfersEnabled() && (
            <>
              <br />
              <br />
              Equipment -{' '}
              <Span
                m="1px"
                bg={`${equipmentColor}.100`}
                color={`${equipmentColor}.500`}
                p="5px 10px"
                borderRadius="10px"
                fontWeight="bold">
                {TransferStatusMap[item?.status?.equipment?.status] || 'N/A'}
              </Span>
            </>
          )}
        </>
      );
    },
  }),
  col.accessor((item) => convertUTCToLocal(item?.createdAt, true, true), {
    id: 'createdAt',
    header: 'Date Tranfer',
    minSize: 150,
    meta: { align: 'center' },
  }),
  col.accessor((item) => item?.fromWashHub?.name || '', {
    id: 'fromWashHub',
    header: 'Wash Hub Origin',
    minSize: 160,
  }),
  col.accessor((item) => item?.toWashHub?.name || '', {
    id: 'toWashHub',
    header: 'Wash Hub Destiny',
    minSize: 160,
  }),
];
